import type {Context} from '../types';

const EXPECTED_TYPES = new Map([
  ['wrapper', 'DynamoWrapper'],
  ['list', 'DynamoList'],
  ['item', 'DynamoItem'],
  ['empty', 'DynamoEmpty'],
]);

export default function (context: Context) {
  const {jsonNode} = context.node;

  const dynType = jsonNode.data?.dyn?.type;
  const expectedType = EXPECTED_TYPES.get(dynType);
  const isCorrupt = Boolean(expectedType && jsonNode.type !== expectedType);

  return {
    needed: isCorrupt,
    logData: {
      msg: 'Dynamo plugin node is missing `node.type`',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      jsonNode.type = expectedType;
    },
  };
}
